<template>
  <slideshow
    @previous="goToPrevious"
    @next="goToNext"
  >
    <template slot="title">
      {{character.name}}
      <small>
        <router-link :to="{name: 'ListCharacters'}">
          Back to characters
        </router-link>
      </small>
    </template>
    <template slot>
      <character-form
        v-bind="character"
        :disabled="isSaving"
        @submit="save"
        @remove="remove"
      />
    </template>
  </slideshow>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Slideshow from '@/components/Slideshow.vue';
import CharacterForm from './CharacterForm.vue';

export default {
  name: 'EditCharacter',
  props: {
    id: String,
  },
  data() {
    return {
      isSaving: false,
    };
  },
  components: {
    CharacterForm,
    Slideshow,
  },
  computed: {
    ...mapGetters(['getCharacter', 'getAllCharacters']),
    character() {
      return this.getCharacter(this.id) || {};
    },
    getIndex() {
      return this.getAllCharacters.findIndex(({ id }) => (this.id === id));
    },
    total() {
      return this.getAllCharacters && this.getAllCharacters.length;
    },
    nextIndex() {
      const nextIndex = this.getIndex + 1;
      return nextIndex >= this.total ? 0 : nextIndex;
    },
    previousIndex() {
      const previousIndex = this.getIndex - 1;
      const lastIndex = this.total - 1;
      return previousIndex >= 0 ? previousIndex : lastIndex;
    },
  },
  mounted() {
    if (!this.getAllCharacters) {
      this.fetch({ model: 'characters' });
    }
  },
  methods: {
    ...mapActions(['update', 'removeCharacter']),
    save(form) {
      this.isSaving = true;
      this.update({
        model: 'characters',
        id: this.id,
        value: form,
      }).then(() => {
        this.isSaving = false;
      });
    },
    remove() {
      this.isSaving = true;
      this.removeCharacter(this.id).then(() => {
        this.$router.push({ name: 'ListCharacters' });
      });
    },
    goToPrevious() {
      const { id } = this.getAllCharacters[this.previousIndex];
      this.$router.push({ params: { id } });
    },
    goToNext() {
      const { id } = this.getAllCharacters[this.nextIndex];
      this.$router.push({ params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-character {
  header {
    text-align: center;
    margin-bottom: 30px;
    div {
      font-weight: 500;
    }
    a {
      font-size: var(--font-small);
    }
  }
}
</style>
